module.exports = __webpack_public_path__ + "img/eagleEye2_7.e46ad245.png";